




























































































	import { Component, Vue } from 'vue-property-decorator';
	import { getMessageList, changeMessageStatus, viewAll } from '@/apis/home';
	import { MESSAGE_TYPE } from '@/utils/constant';
	import { formatShortTime } from '@/utils/common';
	import {sysMessage} from './message'
	@Component({
		name: 'Message',
		components: {},
		filters: {
			timeFormat(value) {
				return formatShortTime(value);
			},
			message(item) {
				if (item.type === 'INNER') {
					return item.message;
				} else {
					return sysMessage(item.message);
				}
			}
		}
	})
	export default class extends Vue {
		private messageType = MESSAGE_TYPE();
		private iconType = {
			INNER: 'iconwenbenqingdan',
			SYSTEM: 'iconshezhi'
		};
		private tabName = {
			all: '全部',
			unread: '未读',
			read: '已读',
			star: '标星'
		};
		private active = 'all';
		private list = [] as any[];
		private filter: any = {};
		// 是否展示详情
		private detailVisible = false;
		private loading = false;
		private finished = false;
    private page = { pageNumber: 0, pageSize: 20, total: 0 };
    private get isDetailShow () {
      return this.$route.params.messageId
    }
		private changeTabs(type) {
			this.active = type;
			this.list = [];
			this.page = { pageNumber: 0, pageSize: 20, total: 0 };
			this.filter = {};
			if (type === 'star') {
				this.filter.focusStatus = true;
			} else if (type === 'unread') {
				this.filter.viewStatus = false;
			} else if (type === 'read') {
				this.filter.viewStatus = true;
			}
			this.finished = true;
			this.getMessageList(true);
		}
		private onLoad() {
			this.getMessageList(false);
		}
		private cardDetail(e, item, index) {
			if (e === 'cell') {
        this.markRead(item, index)
        this.$router.push('/message/' + item.id)
			}
		}
		// 标记已读
		private async markRead(item, index) {
			if (item.viewStatus) {
				return;
			}
			let res = await changeMessageStatus({ id: item.id, viewStatus: true });
			if (res.success) {
				if (this.active === 'unread') {
					this.removeItem(item);
				} else {
					this.list[index].viewStatus = true;
					const swipeCells = this.$refs.swipeCell as any[];
					swipeCells[index].close();
				}
			}
		}
		private removeItem(item) {
			if (this.list.length > 20) {
				let index = this.list.findIndex(one => one.id === item.id);
				if (index !== -1) {
					this.list.splice(index, 1);
					this.page.total = this.page.total - 1;
				}
			} else {
				this.page = { pageNumber: 0, pageSize: 20, total: 0 };
				this.getMessageList(true);
			}
		}
		private async deleteItem(item) {
			let res = await changeMessageStatus({ id: item.id, deleteStatus: true, viewStatus: true });
			if (!res.success) {
				return;
			}
			this.removeItem(item);
		}
		private async focusStatusChange(item, index) {
			let res = await changeMessageStatus({ id: item.id, focusStatus: !item.focusStatus });
			if (res.success) {
				const swipeCells = this.$refs.swipeCell as any[];
				swipeCells[index].close();
				this.list.some((one, key) => {
					if (one.id === item.id) {
						this.list[key].focusStatus = !item.focusStatus;
						return true;
					}
				});
			}
		}
		private async getMessageList(isStart) {
			const pageNum = this.page.pageNumber + 1;
			let res = await getMessageList({
				filter: this.filter,
				page: { pageNumber: pageNum, pageSize: this.page.pageSize, total: this.page.total }
			});
			if (res.success) {
				this.loading = false;
				this.page.pageNumber = pageNum;
				this.page.total = res.data.page.total;
				if (isStart) {
					this.list = res.data.data;
				} else {
					this.list = this.list.concat(res.data.data);
				}
				this.finished = this.list.length >= this.page.total;
			} else {
				this.loading = false;
			}
		}
		private viewAll() {
			if (this.list.length) {
				viewAll().then(res => {
					if (res.success) {
						this.changeTabs('unread');
					}
				});
			}
		}
		private mounted() {
			this.changeTabs('unread');
		}
	}
